
export default function Hero() {
  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden pt-48 md:pt-56 pb-24 md:pb-28">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e327cf7084a27de30d82e65899543e2c.jpg"
          alt="Cinematic cityscape"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col items-center text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight mb-4 md:mb-6" style={{ textShadow: '0 2px 20px rgba(0,0,0,0.4)' }}>
            <span className="block whitespace-nowrap"><span style={{ color: '#D5BA6B' }}>Global</span><span className="text-white"> Sourcing.</span></span>
            <span className="block text-white whitespace-nowrap">Strategic Events.</span>
            <span className="block whitespace-nowrap" style={{ color: '#D5BA6B' }}>Unrivaled Results.</span>
          </h1>
          <p className="text-[11px] sm:text-[13px] md:text-[15px] lg:text-[17px] text-white/90 font-light leading-relaxed whitespace-nowrap mb-8 md:mb-10 tracking-wide" style={{ textShadow: '0 1px 10px rgba(0,0,0,0.3)' }}>
            SITE SELECTION | EVENT MANAGEMENT | INCENTIVE TRAVEL
          </p>
          <button
            onClick={scrollToServices}
            className="group text-black px-8 md:px-10 py-3.5 md:py-4 rounded-full text-sm md:text-base font-semibold hover:brightness-110 transition-all duration-300 whitespace-nowrap shadow-lg hover:shadow-2xl transform hover:scale-105 flex items-center justify-center gap-2 cursor-pointer"
            style={{ backgroundColor: '#D5BA6B' }}
          >
            <span>View Our Services</span>
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-8 h-12 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
